var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({staticStyle:{"text-align":"right"},attrs:{"type":"text","inputmode":"numeric"},domProps:{"value":_vm.formatted},on:{"input":_vm.handleInput,"blur":_vm.handleBlur,"keypress":_vm.preventNonNumeric}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }